<div class="flex flex-row justify-between">
  <div class="flex flex-row items-center">
    <p-breadcrumb
      [model]="[{ label: this.kategorie ?? undefined }, { label: 'Category Info' }]"
      [home]="{ label: 'Kategorien', routerLink: '/kategorien' }"
      />
  </div>
</div>

<h3 class="mt-3">Category Info</h3>

@if (this.isLoading) {
  <div
    class="text-center py-4"
    >
    <p>Lädt Category Info...</p>
  </div>
}

@if (!this.isLoading && this.categoryInfo == null) {
  <p>Keine CategoryInfo gefunden. Bitte Server-Migration laufen lassen.</p>
}

@if (!this.isLoading && this.categoryInfo != null) {
  <div class="flex flex-col gap-4 mt-3">
    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">EXAM</p-tab>
        <p-tab value="1">VC</p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="flex flex-col gap-4">
            <div>
              <label class="block mb-2 font-semibold">Bot Introduction</label>
              <app-reduced-editor
                [(model)]="this.categoryInfo.botIntroductions"
              ></app-reduced-editor>
            </div>

            <div class="flex items-center justify-between">
              <label class="font-semibold">Fallaufgabe Introductions</label>
              <p-button
                icon="pi pi-plus"
                severity="secondary"
                label="Eintrag hinzufügen"
                (onClick)="this.addIntroduction('exam')"
                />
            </div>

            @for (intro of this.categoryInfo.fallAufgabeIntroductions; track $index) {
              <div class="border rounded p-3 flex flex-col gap-2">
                <div class="flex gap-2 items-center">
                  <div class="flex-1">
                    <input
                      pInputText
                      [(ngModel)]="intro.title"
                      placeholder="Titel"
                      class="w-full"
                      />
                  </div>
                  <p-button
                    icon="pi pi-arrow-up"
                    [outlined]="true"
                    [disabled]="$index === 0"
                    (onClick)="this.moveIntroductionUp('exam', $index)"
                    />
                  <p-button
                    icon="pi pi-arrow-down"
                    [outlined]="true"
                    [disabled]="$index === this.categoryInfo.fallAufgabeIntroductions.length - 1"
                    (onClick)="this.moveIntroductionDown('exam', $index)"
                    />
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [outlined]="true"
                    (onClick)="this.removeIntroduction('exam', $index)"
                    />
                </div>

                <app-reduced-editor
                  [(model)]="intro.content"
                ></app-reduced-editor>
              </div>
            }

            <div>
              <label class="block mb-2 font-semibold">Fallaufgabe Outro</label>
              <app-reduced-editor
                [(model)]="this.categoryInfo.FallaufgabeOutro"
              ></app-reduced-editor>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1">
          <div class="flex flex-col gap-4">
            <div class="vc-sample-rate-field">
              <label class="block mb-2 font-semibold" for="vcSampleRate">VC Stichprobe: jede wievielte Fallaufgabe</label>
              <p-inputnumber
                id="vcSampleRate"
                [(ngModel)]="this.categoryInfo.vcSampleRate"
                [min]="1"
                [step]="1"
                [showButtons]="true"
                buttonLayout="horizontal"
                spinnerMode="horizontal"
                mode="decimal"
                [useGrouping]="false"
                styleClass="vc-sample-rate-input"
                >
                <ng-template #incrementbuttonicon>
                  <span class="pi pi-plus"></span>
                </ng-template>
                <ng-template #decrementbuttonicon>
                  <span class="pi pi-minus"></span>
                </ng-template>
              </p-inputnumber>
              <small class="text-surface-600">Beispiel: 10 bedeutet, dass jeder 10. VC fuer eine Stichprobe vorgesehen ist.</small>
            </div>

            <div>
              <label class="block mb-2 font-semibold">Bot Introduction VC</label>
              <app-reduced-editor
                [(model)]="this.categoryInfo.vcBotIntroductions"
              ></app-reduced-editor>
            </div>

            <div class="flex items-center justify-between">
              <label class="font-semibold">Fallaufgabe Introductions VC</label>
              <p-button
                icon="pi pi-plus"
                severity="secondary"
                label="Eintrag hinzufügen"
                (onClick)="this.addIntroduction('vc')"
                />
            </div>

            @for (intro of this.categoryInfo.vcIntroductions; track $index) {
              <div class="border rounded p-3 flex flex-col gap-2">
                <div class="flex gap-2 items-center">
                  <div class="flex-1">
                    <input
                      pInputText
                      [(ngModel)]="intro.title"
                      placeholder="Titel"
                      class="w-full"
                      />
                  </div>
                  <p-button
                    icon="pi pi-arrow-up"
                    [outlined]="true"
                    [disabled]="$index === 0"
                    (onClick)="this.moveIntroductionUp('vc', $index)"
                    />
                  <p-button
                    icon="pi pi-arrow-down"
                    [outlined]="true"
                    [disabled]="$index === this.categoryInfo.vcIntroductions.length - 1"
                    (onClick)="this.moveIntroductionDown('vc', $index)"
                    />
                  <p-button
                    icon="pi pi-trash"
                    severity="danger"
                    [outlined]="true"
                    (onClick)="this.removeIntroduction('vc', $index)"
                    />
                </div>

                <app-reduced-editor
                  [(model)]="intro.content"
                ></app-reduced-editor>
              </div>
            }

            <div>
              <label class="block mb-2 font-semibold">VC Outro</label>
              <app-reduced-editor
                [(model)]="this.categoryInfo.vcOutro"
              ></app-reduced-editor>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <div>
      <p-button
        icon="pi pi-save"
        label="Speichern"
        (onClick)="this.save()"
        />
    </div>
  </div>
}
